'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getParents = require('./get-parents');

var _getParents2 = _interopRequireDefault(_getParents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filterTree = function filterTree() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      fieldName = _ref.fieldName,
      _ref$idField = _ref.idField,
      idField = _ref$idField === undefined ? 'id' : _ref$idField,
      _ref$parentField = _ref.parentField,
      parentField = _ref$parentField === undefined ? 'parent' : _ref$parentField;

  return function (rows) {
    if (!fieldName) {
      throw new Error('tree.filterTree - Missing fieldName!');
    }

    // build up a cache of parent ids and whether their child rows should show
    // to reduce the amount of lookups for performance
    var parentCache = {};

    return rows.filter(function (row, index) {
      if (typeof row[parentField] === 'undefined' || row[parentField] === null) {
        return true;
      }

      var parentVal = parentCache[row[parentField]];
      if (parentVal === false || parentVal === true) {
        return parentVal;
      }

      var parents = (0, _getParents2.default)({ index: index, idField: idField, parentField: parentField })(rows);

      // if all the rows parents are showing then we know that the row should should
      var rowShouldShow = parents.filter(function (parent) {
        return parent[fieldName];
      }).length === parents.length;

      parentCache[row[parentField]] = rowShouldShow;

      return rowShouldShow;
    });
  };
};

exports.default = filterTree;